<div class="google-login-button">
  <div tabindex="0" role="button" #buttonContainer (click)="gauth.signIn()">
    <span>{{ trans('auth.googleSignIn') }}</span>
  </div>
</div>
